var map = {
	"./page/compare/compare.module": "./src/app/page/compare/compare.module.ts",
	"./page/cookies/cookies.module": "./src/app/page/cookies/cookies.module.ts",
	"./page/faqs/faqs.module": "./src/app/page/faqs/faqs.module.ts",
	"./page/feedback/feedback.module": "./src/app/page/feedback/feedback.module.ts",
	"./page/generate-reset-password-token/generate-reset-password-token.module": "./src/app/page/generate-reset-password-token/generate-reset-password-token.module.ts",
	"./page/glossary/glossary.module": "./src/app/page/glossary/glossary.module.ts",
	"./page/home/home.module": "./src/app/page/home/home.module.ts",
	"./page/login/login.module": "./src/app/page/login/login.module.ts",
	"./page/products/products.module": "./src/app/page/products/products.module.ts",
	"./page/reset-password/reset-password.module": "./src/app/page/reset-password/reset-password.module.ts",
	"./page/results/results.module": "./src/app/page/results/results.module.ts",
	"./page/stop-data-collection/stop-data-collection.module": "./src/app/page/stop-data-collection/stop-data-collection.module.ts",
	"./page/supplier/supplier.module": "./src/app/page/supplier/supplier.module.ts",
	"./page/terms-conditions/terms-conditions.module": "./src/app/page/terms-conditions/terms-conditions.module.ts",
	"./page/unbiased/unbiased.module": "./src/app/page/unbiased/unbiased.module.ts",
	"./page/verify/verify.module": "./src/app/page/verify/verify.module.ts",
	"./page/what-next/what-next.module": "./src/app/page/what-next/what-next.module.ts",
	"./page/who-we-are/who-we-are.module": "./src/app/page/who-we-are/who-we-are.module.ts",
	"./page/your-data-rights/your-data-rights.module": "./src/app/page/your-data-rights/your-data-rights.module.ts",
	"./page/your-data-use/your-data-use.module": "./src/app/page/your-data-use/your-data-use.module.ts"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;